<template lang="pug">
img.b-avatar.-exists(v-if="user && user.id && user.avatar" :class="{ large, small }" :src="userImage" :title="userTitle" :style="styles" @dblclick="switchToUser")
.b-avatar.-no-image(v-else-if="user && user.id && !user.avatar" :class="{ large, small }" :title="userTitle" :style="styles" @dblclick="switchToUser")
  Icon(name="no-avatar" pointer)
.b-avatar.-no-user(v-else :class="{ large, small }" :title="userTitle" :style="styles")
  Icon(name="question" pointer)
</template>

<script>
import user from '@/model/user';

export default {
  name: 'UserAvatar',
  props: {
    user: Object,
    large: Boolean,
    small: Boolean,
    size: Number,
  },
  computed: {
    styles() {
      if (!this.size) return {};

      const radius = Math.ceil(this.size / 2.75);

      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'border-radius': `${radius}px`,
      };
    },
    userTitle() {
      if (!this.user) {
        return '';
      }

      return this.user.name ? `${this.user.name} ${this.user.surname}` : this.user.email;
    },
    userImage() {
      const file = this.user?.avatar;

      if (!file) return '';

      const thumbnail = this.large ? file.thumbnails?.avatar_large : file.thumbnails?.avatar;

      return thumbnail ?? file.url;
    },
  },
  methods: {
    switchToUser() {
      // if (this.$store.state.auth.user.roles)
      const { roles } = this.$store.state.auth.user;

      if (roles.includes('ROLE_SUPER_ADMIN') || roles.includes('ROLE_ALLOWED_TO_SWITCH')) {
        user.impersonate(this.user.email);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.avatar {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  border-radius: 16px;

  &--exists {
    object-fit: cover;
    border: 2px solid #ffffff;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.16));
  }

  &--no-image {
    border: 2px solid #ffffff;
    background: var(--color-purple);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.16));
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 45%;
      height: auto;
    }
  }

  &--no-user {
    background: #fff;
    border: 1px dashed var(--color-middle-gray);
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 60%;
      height: auto;
    }
  }

  &.small {
    width: 30px;
    height: 30px;
    border-radius: 14px;
  }

  &.large {
    width: 184px;
    height: 184px;
    border-radius: 55px;
  }
  &--exists.large {
    border: 5px solid #ffffff;
  }
}
</style>
